import React from 'react';

import Button from 'components/Buttons/Button';
import useGlobalBottomSheet from 'hooks/useGlobalBottomSheet';
import useStoreTranslation from 'hooks/useStoreTranslation';
import history from 'utils/history';

import { Container, Title, Detail, Item, ExclamationIcon, ButtonsContainer, CancelButton } from './styles';

type Props = {
  hasLineOfCredit: boolean;
  billingCompleted: boolean;
  paymentCompleted: boolean;
  onClose: () => void;
};

const IncompleteCompany = ({ hasLineOfCredit, billingCompleted, paymentCompleted, onClose }: Props) => {
  const { t } = useStoreTranslation();
  const bottomSheet = useGlobalBottomSheet();

  const isProfileCompleted = billingCompleted && paymentCompleted;

  const handleSecondaryClick = () => {
    if (isProfileCompleted) history.push('/corporate/settings');
    onClose();
  };
  const handlePrimaryClick = () => {
    if (isProfileCompleted) {
      onClose();
      return;
    }
    history.push(!billingCompleted ? '/corporate/companyBillingEdit' : '/corporate/paymentMethods', {
      completingCompanyProfile: true,
      paymentCompleted,
    });
    bottomSheet.reset();
  };

  return (
    <Container>
      <Title>
        <ExclamationIcon />{' '}
        {isProfileCompleted ? t('dashboard.companyInAnalysis.title') : t('dashboard.incompleteCompany.title')}
      </Title>
      <Detail>
        {isProfileCompleted ? t('dashboard.companyInAnalysis.detail') : t('dashboard.incompleteCompany.detail')}
      </Detail>

      {(isProfileCompleted || !billingCompleted) && <Item>{t('billing.profile.title')}</Item>}
      {!hasLineOfCredit && (isProfileCompleted || !paymentCompleted) && (
        <Item>{t('companySettings.paymentMethods')}</Item>
      )}

      <ButtonsContainer>
        <CancelButton onClick={handleSecondaryClick}>
          {isProfileCompleted
            ? t('dashboard.companyInAnalysis.buttons.edit')
            : t('dashboard.incompleteCompany.buttons.cancel')}
        </CancelButton>
        <Button
          value={
            isProfileCompleted
              ? t('dashboard.companyInAnalysis.buttons.ok')
              : t('dashboard.incompleteCompany.buttons.complete')
          }
          onClick={handlePrimaryClick}
        />
      </ButtonsContainer>
    </Container>
  );
};

export default IncompleteCompany;
